export default __webpack_public_path__ + "caa883e63ca2c4795a261d0eac125f57.png";